import { Box, FormControl, RadioGroup, Typography } from '@mui/material'
import AdxCheckbox from 'components/custom/AdxCheckbox'
import AdxFormControlLabel from 'components/custom/AdxFormControlLabel'
import AdxInput from 'components/custom/AdxInput'
import AdxRadioButton from 'components/custom/AdxRadioButton'
import React, { useEffect, useState } from 'react'
import AltToggleButton from '../../createForm/components/altToggleButton'

const AltDisplayQuestion = ({
  valueResponse,
  valueType,
  valueRequired,
  valueQuestion,
  valueOption,
  sectIndex,
  quesIndex,
  quesKey,
  handleResponse,
  formPage,
  ...sxCard
}) => {
  const [checkboxValue, setCheckboxValue] = useState([])

  const [answerValue, setAnswerValue] = useState(
    valueResponse.length !== 0 ? valueResponse[0] : undefined
  )

  useEffect(() => {
    setAnswerValue(valueResponse[0] !== undefined ? valueResponse : '')
  }, [valueResponse])

  useEffect(() => {
    if (valueType === '4') {
      handleResponse(quesKey, checkboxValue.join(', '))
    }
  }, [checkboxValue])

  useEffect(() => {
    if (
      answerValue !== valueResponse[0] &&
      (valueResponse[0] !== undefined || answerValue !== '')
    ) {
      const delay = setTimeout(() => {
        handleResponse(quesKey, answerValue)
      }, 200)
      return () => clearTimeout(delay)
    }
  }, [answerValue])

  const handleCheckbox = (i, event) => {
    const updateCheckboxArray = (array, value, checked) => {
      return checked ? [...array, value] : array.filter((v) => v !== value)
    }

    const checkboxArray = updateCheckboxArray(checkboxValue, i, event.target.checked)

    setCheckboxValue(checkboxArray)
  }

  const handleScaleValue = (value) => {
    handleResponse(quesKey, value)
  }

  const showValue = () => {
    let values = {
      quesKey: quesKey,
      valueType: valueType,
      valueRequired: valueRequired,
      valueQuestion: valueQuestion,
      valueOption: valueOption,
      valueResponse: valueResponse,
    }
  }

  const renderQuestion = () => {
    switch (valueType) {
      case '1':
        return (
          <AdxInput
            placeholder={'Enter your answer here'}
            value={answerValue}
            onChange={(i) => setAnswerValue(i.target.value)}
            multiline
          />
        )
      case '2':
        return (
          <AltToggleButton
            valueStart={valueOption[0] ?? 1}
            valueEnd={valueOption[1] ?? 5}
            labelStart={valueOption[2] ?? ''}
            labelEnd={valueOption[3] ?? ''}
            handleScaleValue={handleScaleValue}
            valueResponse={valueResponse}
            sx={{ height: 45 }}
          />
        )
      case '3':
        return (
          <FormControl>
            <RadioGroup value={answerValue} onChange={(i) => setAnswerValue(i.target.value)}>
              {valueOption !== undefined
                ? valueOption.map((i, index) => (
                    <AdxFormControlLabel
                      checked={i === answerValue}
                      type="no-fill"
                      selected={answerValue}
                      value={i}
                      control={<AdxRadioButton />}
                      label={i}
                      key={index}
                    />
                  ))
                : null}
            </RadioGroup>
          </FormControl>
        )
      case '4':
        return (
          <>
            {valueOption !== undefined
              ? valueOption.map((i, index) => (
                  <AdxFormControlLabel
                    checked={checkboxValue.includes(i)}
                    type="no-fill"
                    control={<AdxCheckbox />}
                    label={i}
                    onChange={(event) => handleCheckbox(i, event)}
                    key={index}
                  />
                ))
              : null}
          </>
        )
      default:
        break
    }
  }

  return (
    <Box
      sx={{
        width: '100%',
        height: 'auto',
        paddingTop: '16px',
        paddingBottom: '20px',
        paddingX: '16px',
        borderRadius: '10px',
        display: 'flex',
        flexDirection: 'row',
        ...sxCard,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
        }}
        gap={2.5}
      >
        <Typography variant="h4" fontWeight="regular" onClick={() => showValue()}>
          <span>
            {valueQuestion} {valueRequired ? <span style={{ color: 'red' }}>*</span> : ''}
          </span>
        </Typography>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'flex-start',
            marginBottom: '10px',
          }}
        >
          {renderQuestion()}
        </Box>
      </Box>
    </Box>
  )
}

export default AltDisplayQuestion
